import Table, { ColumnsType } from "antd/es/table";
import { getContentHistoryApi } from "api/membership";
import CsTable from "components/Table";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const ContentTable: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  // const totalElement = 100;
  const { userId } = useParams();

  const [dataTable, setDataTable] = useState<{
    data: any;
    totalElement: number;
  }>({ data: [], totalElement: 0 });

  const getContentHistory = async () => {
    if (!userId) return;
    const { data, error }: any = await getContentHistoryApi({
      userId: +userId,
      page: Number(searchParams.get("page")) || 1,
      size: 10,
    });
    if (error) {
      console.error(error);
      return;
    }
    if (data.datas) {
      setDataTable({
        data: data.datas,
        totalElement: data?.pageable.totalElement,
      });
    }
  };

  useEffect(() => {
    getContentHistory();
  }, [searchParams.get("page")]);

  const columns: ColumnsType<any> = [
    {
      title: "No",
      dataIndex: "cl1",
      key: "cl1",
      width: "18.19%",
      render: (_, record) => <div>{record.id}</div>,
    },
    {
      title: "방문일시",
      dataIndex: "cl2",
      key: "cl2",
      width: "24.79%",
      render: (_, record) => (
        <div>
          {dayjs(record?.createdTime).format("YYYY-MM-DD")}
          <br />
          {dayjs(record?.createdTime).format("HH:mm:ss")}
        </div>
      ),
    },
    {
      title: "내용",
      dataIndex: "cl3",
      key: "cl3",
      width: "75.21%",
      render: (_, record) => (
        <div>{record?.typeUsed === "FEED" ? "피드" : "커뮤니티"}</div>
      ),
    },
  ];

  return (
    <div>
      <Table
        // onChange={handleTableChange}
        bordered
        className="center-table"
        columns={columns}
        dataSource={dataTable.data}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: () => handleRowClick(record), // Click vào hàng
        //   };
        // }}
        pagination={
          dataTable.totalElement >= 10
            ? {
                current: Number(searchParams.get("page")) || 1,
                total: dataTable.totalElement,
                pageSize: 10,
                showSizeChanger: false,
                onChange: (page) => {
                  searchParams.set("page", page.toString());
                  setSearchParams(searchParams);
                },
              }
            : false
        }
      />
    </div>
  );
};
export default ContentTable;
